import React, { useState } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import imageService from '../../service/ImageServie';

function AdCard({ advertisement, onViewDetails }) {

  const [showNumber, setShowNumber] = useState(false);

  const formatPhoneNumber = (phoneNumber) => {
    // Format phone number as (XXX) XXX-XXXX
    return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  };

  const handlePhoneClick = (phone) => {
    if (showNumber) {
      // Initiate a call (this will only work if your environment supports such functionality)
      window.location.href = `tel:${phone}`;
    }
    else {
      // Make the phone number visible
      setShowNumber(true);
    }
  };

  return (<>
    <Card className="mb-3 internal_ads_row col-lg-10 col-md-11 px-0 text-start border-blk">
      <Row className='mx-0'>
        <Col className='px-0 order-md-1 order-2' md={advertisement.imageName ? 9 : 12}>
          <Card.Body className='planCard-style h-100 position-relative pb-0 pt-2 d-flex flex-column'>
            <Row className="flex-grow-1 mb-1">
              <div className='col-md-12'>
                <div className='row justify-content-between align-items-center'>
                  <div className='cardText col-md-5 col-lg-6 col-12'>
                    <Card.Title style={{ cursor: "pointer"}} onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}>
                          {advertisement.companyName}
                    </Card.Title>
                  </div>

                  <div className='cardText col-md-5 col-lg-4 col-8'>
                    <h6 className='ad_worktype'>Work Type : <b>{advertisement.shopType || 'Not Available'}</b></h6>
                  </div>

                  <div className='cardText col-md-2 col-4 text-right'>
                    <span className='ad_miles mb-0'>{advertisement.distance.toFixed(1)} miles</span>
                  </div>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='cardText'>
                  <p className='ad_address mb-0'><i className="fas fa-location-dot" title="location"></i> {advertisement.address || `${advertisement.city}, ${advertisement.state}`}</p>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='cardText d-md-flex gap-3'>
                  <p className='ad_email mb-0'><i className="fa fa-envelope" title="email"></i> {advertisement.email || 'Not Available'}</p>
                  <p className='ad_website mb-0'><i className="fa fa-globe" title="website"></i>
                    <a href={advertisement.website} rel="noopener noreferrer"> {advertisement.website || 'Not Available'}</a>
                  </p>
                </div>
              </div>

              <div className='col-md-12'>
                <div className='ad_services'>
                  <ul className='ad_serviceList'>
                    {advertisement.services.slice(0, 4).map((service, index) => (
                      <li key={index}>{service}</li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className='col-md-12'>
                <div className="ad_description">
                  <p className='mb-0'>
                    {advertisement.description?.length > 75
                      ? <>
                        {advertisement.description.slice(0, 75)}...
                        <span
                          className="read-more-link"
                          onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}
                        > Read more</span>
                      </>
                      : advertisement.description
                    }
                  </p>
                </div>
              </div>
            </Row>

            <div className='row align-items-center mt-auto plan_actions_column'>
              <div className='new-ad-bottom col-md-4 order-2 order-md-1'>
                <div className='bd_plan_contact text-center'>
                  <a href={`tel:${advertisement.phone}`} className="btn mb-0 py-1 showNumber">
                    <i className="fa fa-phone"></i> {formatPhoneNumber(advertisement.phone)}
                  </a>
                </div>
              </div>

              <div className='col-md-4 order-1 order-md-2 border-left border-right py-2'>
                <div className='planPrice-style text-center'>
                  <h6 className='ad_hours'><i className="far fa-clock" title="time"></i> {advertisement.workingHours}</h6>
                </div>
              </div>

              <div className='col-md-4 order-3 order-md-3'>
                <div className='planPrice-style'>
                  <Button className='planBtn' variant="primary" onClick={() => onViewDetails(advertisement.id, advertisement.companyName)}>View Detail</Button>
                </div>
              </div>
            </div>

          </Card.Body>
        </Col>

        {advertisement.imageName && (
          <Col md={3} className='p-0 align-content-around ad_banner order-md-2 order-1'>
            <Card.Img variant="top"
              src={`${imageService.getAdsImage}${advertisement.imageName}`}
              alt={advertisement.companyName}
            />
          </Col>
        )}

      </Row>
    </Card>

  </>

  );
}

export default AdCard;